import { fetchGetCompanies, fetchSessionCompanies } from "./actions";
import {
  getCompanies,
  getCompanyNameById,
  getIsCompaniesLoaded,
} from "./selectors";
import CompaniesSlice from "./reducers";

// actions
export const { resetCompanies } = CompaniesSlice.actions;

// async actions
export { fetchGetCompanies, fetchSessionCompanies };

// selectors
export { getCompanies, getCompanyNameById, getIsCompaniesLoaded };

// reducer
export default CompaniesSlice.reducer;
